import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Registration } from '../../../../schemas'
import {
  Col,
  Container,
  ErrorMessage,
  FormInput,
  FormSelect,
  Option,
} from '../../../basics'
import { FormRow } from '../FormRow'

const translateNamespace = 'components.UsageInfoForm'

// 11:00〜19:00 を 1 時間刻みで提示 (= 9 個)
const CHECK_IN_TIME_START_HOUR = 11
const CHECK_IN_TIME_END_HOUR = 19
const checkInTimeOptions = Array.from(
  { length: CHECK_IN_TIME_END_HOUR - CHECK_IN_TIME_START_HOUR + 1 },
  (_, i) => `${(CHECK_IN_TIME_START_HOUR + i).toString().padStart(2, '0')}:00`
)

type UsageInfoFormProps = {
  showCompanyName?: boolean
  showPurposeOfUse?: boolean
  showCheckInTime?: boolean
}

export const UsageInfoForm: React.FC<UsageInfoFormProps> = ({
  showCompanyName = false,
  showPurposeOfUse = false,
  showCheckInTime = false,
}) => {
  const { t } = useTranslation()
  const {
    control,
    formState: { errors },
  } = useFormContext<Registration>()

  return (
    <Container>
      {showCompanyName && (
        <FormRow>
          <Col>
            <FormInput
              control={control}
              name="companyName"
              inputMode="text"
              label={t(`${translateNamespace}.companyName.label`)}
              placeholder={t(`${translateNamespace}.companyName.placeholder`)}
              maxLength={255}
            />
            <ErrorMessage errors={errors} name="companyName" />
          </Col>
        </FormRow>
      )}
      {showPurposeOfUse && (
        <FormRow>
          <Col>
            <FormInput
              control={control}
              name="purposeOfUse"
              inputMode="text"
              label={t(`${translateNamespace}.purposeOfUse.label`)}
              placeholder={t(`${translateNamespace}.purposeOfUse.placeholder`)}
              maxLength={255}
            />
            <ErrorMessage errors={errors} name="purposeOfUse" />
          </Col>
        </FormRow>
      )}
      {showCheckInTime && (
        <FormRow>
          <Col>
            <FormSelect
              control={control}
              name="checkInTime"
              label={t(`${translateNamespace}.checkInTime.label`)}
            >
              <Option value="">
                {t(`${translateNamespace}.checkInTime.placeholder`)}
              </Option>
              {checkInTimeOptions.map((time) => (
                <Option key={time} value={time}>
                  {time}
                </Option>
              ))}
            </FormSelect>
            <ErrorMessage errors={errors} name="checkInTime" />
          </Col>
        </FormRow>
      )}
    </Container>
  )
}
